export const NAME = 'parameters-winds';
